<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T14:52:33+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Template for other pages than the Landing page
@Last modified by:   tom
@Last modified time: 2019-05-16T12:29:46+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Example:

   out = text to write to screen one character at a time.
   once = to write each tim we show page, default is false, so rewrite always when page it is mounted
   height = height of complete block to avoid jiggering

  <typewriter
    :out="$t('title.subtitle')"
    once
    height="4em;"
    class="mb-0 mx-auto" />
-->

<template>
  <div :style="{ 'height': height }" class="typewriter text-center" />
</template>

<script>
// type speed variable
const TYPESPEED = 40
let writeDone = false

export default {
  name: 'TypeWriter',
  props: {
    height: { type: String, default: '' }, // the height of the block, to prevent flowing
    out: { type: String, default: 'Lorem ipsum typing effect!' },
    once: { type: Boolean, default: false }
  },
  data () {
    return {
      i: 0 // steps to show to animate
    }
  },
  mounted () {
    // start typing now
    this.typeWriter()
  },
  methods: {
    typeWriter: function () {
      const self = this
      if (writeDone && self.once) {
        // we have the text and we only show once... so keep it
        self.$el.innerHTML = self.out
      } else {
        if (self.i < self.out.length) {
          self.$el.innerHTML += self.out.charAt(self.i)
          self.i++
          setTimeout(self.typeWriter, TYPESPEED)
        } else if (self.once) {
          writeDone = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .typewriter {
    font-family: $font-family-monospace;
    font-size: 0.9em;
    width: 100%;
  }

</style>
